<template>
<!--Product Area Start-->
<section>

    <ProductCard :product = "product"/>
                     
</section>

</template>

<script>
    import ProductCard from './../ProductCard';

    export default {
        components: { ProductCard },

        props: ['product'],
    };
</script>
